<template>
  <BaseModal ref="baseModalRef" :title="'Reportes'" modal-id="reports" :isVisible="true" @close="closeDialog"
    @minimize="$emit('minimize', 'reports')" @restore="$emit('restore', 'reports')">
    <div id="buscador" class="form">
      <div class="container-fluid">
        <div class="form events-window">
          <h5 class="col-12 ml-0">
            <div class="filters-show" @click="toggleFilters" style="cursor: pointer">
              <i :class="showFilters ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
              <i class="bi bi-funnel"></i> Filtrar
            </div>
          </h5>

          <!-- INICIO FILTROS -->
          <div v-if="showFilters" class="row filter-box col-12">
            <div class="col-4 col-6-small">
              <!-- Generico fechas -->
              <filtro-fechas v-model:start-date="startDate" v-model:end-date="endDate" />
            </div>
          </div>
        </div>
        <div class="row list-box">
          <div class="col-list">
            <div class="text-center">
              <label class="reports-title">Reportes Filtrados <span class="count-badge">({{ cantidadReports
                  }})</span></label>
            </div>

            <!-- Lista responsive de reportes -->
            <div class="reports-list-container" style="height: 100%">
              <div v-for="report in reportFiles" :key="report.report_id" class="report-item"
                :class="{ selected: selectedReport?.report_id === report.report_id }" @click="changeReport(report)">
                <div class="report-item-content">
                  <!-- Solo nombre del reporte -->
                  <div class="report-name">{{ report.name }}</div>
                  <div v-if="selectedReport?.report_id === report.report_id" class="selection-indicator">
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                </div>
              </div>

              <!-- Mensaje cuando no hay reportes -->
              <div v-if="reportFiles.length === 0" class="no-reports">
                <i class="bi bi-file-earmark-text"></i>
                <p>No se encontraron reportes</p>
              </div>
            </div>
          </div>

          <div class="datos-report">
            <h5 class="my-3">{{ selectedReport.name }}</h5>
            <h5 class="my-3">{{ selectedReport.utc.replace('T', ' ') }}</h5>
            <div ref="imageContainer" class="report-container">
              <iframe class="frame-report" :src="'/fserver/documents/reports/' +
                selectedReport.type.trim() +
                selectedReport.type_version.trim() +
                '/' +
                getYearMonth(selectedReport.utc) +
                '/' +
                selectedReport.pdf_name.replace('Stills', 'stills').replace('\\', '/')
                " width="100%" style="border: none"></iframe>
              <button @click="toggleFullScreen" class="btn btn-secondary btn-sm me-1 d-block">
                Ampliar a Pantalla Completa
              </button>
              <button @click="gotoRelated" class="btn btn-secondary btn-sm d-block">
                Ir a {{ selectedReport.type === 'RM' ? 'OM' : 'ROA' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import { ref, defineEmits, onMounted, watch, defineProps } from 'vue'
import BaseModal from './base/BaseModal.vue'
import type { ReportFile, Evento } from '../types'
import API from '../services'
import { AxiosError } from 'axios'
import FiltroFechas from './base/FiltroFechas.vue'
import { useGlobalStore } from '@/stores/global'
import { storeToRefs } from 'pinia'

const reportFiles = ref<ReportFile[]>([])
const cantidadReports = ref(0)
const selectedReport = ref<ReportFile>({
  number: '48324',
  creator: 'Bernardo',
  utc: '2024-11-28T13:07:22.201-03:00',
  report_id: '2244',
  file_name: 'ROA0707_2024\\ROA0707_2024.rm',
  pdf_name: 'ROA0707_2024\\ROA0707_2024_270800 - 282000-NOVIEMBRE.pdf',
  mission_plan_id: '-1',
  origin: 'LA  ',
  name: 'ROA0707_2024',
  type: 'RM',
  type_version: '1.0',
  link_id: '30',
  mission: 0
})
const globals = useGlobalStore()
const { missionEvents, viewCurrentMissionEvents } = storeToRefs(globals)
const startDate = ref<string>('')
const endDate = ref<string>('')
const reportType = ref<string>('RM')

const imageContainer = ref<HTMLElement | null>(null)
const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
  (event: 'gotoRelated', report: ReportFile): void
}>()
const showFilters = ref(false) // Controla la visibilidad de filter-box
const baseModalRef = ref()
// Declare viewReport as a ref (initialize as null or with a default value as needed)

defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal();
    }
  },
});
const props = defineProps<{
  viewReport: ReportFile | null;
}>();

watch(
  () => props.viewReport,
  (newReport) => {
    if (newReport) {
      changeReport(newReport);
    }
  },
  { immediate: true } // Ejecutar el watch inmediatamente al montar el componente
);

function gotoRelated() {
  relatedReport(
    selectedReport.value.mission.toString(),
    selectedReport.value.type === 'RM' ? 'OM' : 'RM'
  )
  if (selectedReport.value.type === 'OM') {
    viewCurrentMissionEvents.value = false
  } else {
    viewCurrentMissionEvents.value = true
  }
}
function closeDialog() {
  emit('closed')
}
function changeReport(report: ReportFile) {
  selectedReport.value = report
  if (selectedReport.value.type === 'RM') {
    getReportsEvents(selectedReport.value.report_id)
    viewCurrentMissionEvents.value = true
  } else {
    missionEvents.value = []
  }
}
onMounted(() => {
  callApi()
})
function getYearMonth(utc: string): string {
  // Extrae los primeros 7 caracteres: "2025-01"
  return utc.substring(0, 7).replace('-', '/')
}
async function callApi() {
  const filters = {
    start_date: startDate.value.replace(/-/g, ''),
    end_date: endDate.value.replace(/-/g, ''),
    type: reportType.value === 'Todos' ? undefined : reportType.value
  }

  try {
    const { status, data } = await API.listReportFiles(filters)

    if (status == 200 && data.Entries && Array.isArray(data.Entries.Entry)) {
      reportFiles.value = data.Entries.Entry
      cantidadReports.value = reportFiles.value.length
    } else {
      reportFiles.value = []
      cantidadReports.value = 0
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
    reportFiles.value = []
    cantidadReports.value = 0
  }
}
async function relatedReport(mission: string, reportType: string) {
  const filters = {
    type: reportType,
    mission: mission
  }
  try {
    const { status, data } = await API.listReportFiles(filters)

    if (status == 200 && data.Entries && Array.isArray(data.Entries.Entry) && data.Entries.Entry.length > 0) {
      emit('gotoRelated', data.Entries.Entry[0])
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
  }
}

function toggleFullScreen() {
  if (!document.fullscreenElement) {
    imageContainer.value?.requestFullscreen().catch((err: Error) => {
      alert(`Error al intentar entrar en modo de pantalla completa: ${err.message} (${err.name})`)
    })
  } else {
    document.exitFullscreen()
  }
}

function toggleFilters() {
  showFilters.value = !showFilters.value
}



async function getReportsEvents(reportId: string) {
  try {
    const { status, data } = await API.listReportsEvents(reportId)
    if (status == 200) {
      if (data.Entries && Array.isArray(data.Entries.Entry)) {
        // Convertir location de JSON string a JSON object
        const entriesWithParsedLocation = data.Entries.Entry.map((entry: Evento) => {
          if (entry.location && typeof entry.location === 'string') {
            try {
              entry.location = JSON.parse(entry.location);
            } catch (error) {
              console.error('Error al parsear location:', error);
            }
          }
          return entry;
        });

        console.log('Eventos de reportes obtenidos:', entriesWithParsedLocation.length);
        missionEvents.value = entriesWithParsedLocation;
      } else {
        console.log('No existen eventos de ese reporte');
      }
    } else {
      console.error('Error obteniendo eventos de reportes');
    }
  } catch (error) {
    const _error = error as AxiosError<string>;
    console.error(_error.message);
  }
}
</script>

<style lang="css" scoped>
input,
.form-select label {
  max-width: 100%;
}

.filters-small .tipo {
  height: 30px;
}

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.modal-container {
  min-width: 490px;
  width: 500px;
  height: 450px;
  min-height: 330px;
  max-height: 85vh;
}

.form-select {
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
}

.row,
.col-10 {
  padding-right: 0%;
  justify-content: space-evenly;
}

h5 {
  height: max-content;
}

input,
.form-select label {
  max-width: 100%;
}

input.form-text-input,
input.form-number-input,
label.form-text-label {
  font-size: 12px;
}

.form,
.container-fluid,
.col-2,
.col-5 {
  height: 100%;
}

.report-container {
  width: 100%;
  height: calc(100% - 150px);
  position: relative;
}

.frame-report {
  width: 100%;
  height: 100%;
  border: none;
}

/* Estilos para la lista de reportes */
.reports-title {
  font-weight: 600;
  color: white;
  font-size: 14px;
}

.count-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.reports-list-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.reports-list-container::-webkit-scrollbar {
  width: 6px;
}

.reports-list-container::-webkit-scrollbar-track {
  background: transparent;
}

.reports-list-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.report-item {
  margin-bottom: 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
}

.report-item:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.report-item.selected {
  background: rgba(91, 161, 223, 0.3);
  border-color: #5ba1df;
  box-shadow: 0 2px 8px rgba(91, 161, 223, 0.3);
}

.report-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  position: relative;
}

.report-name {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: white;
  word-break: break-word;
  line-height: 1.3;
  min-width: 0;
}

.selection-indicator {
  color: #5ba1df;
  font-size: 16px;
  margin-left: 8px;
  flex-shrink: 0;
}

.no-reports {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
}

.no-reports i {
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
}

.no-reports p {
  margin: 0;
  font-size: 14px;
}

.events-window {
  margin: 0px 10px;
  margin-top: 0px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 100%;
  height: max-content;
}

@media (max-width: 576px) {
  .modal-container-small {
    max-width: 90vw;
    min-width: 200px;
    width: 90vw;
    height: 480px;
    min-height: 400px;
  }

  .col-2 {
    height: fit-content;
  }

  .col-3 {
    height: 200px;
  }

  .col-5 {
    width: 100%;
    margin-top: 30px;
  }
}

.filter-box .form-check {
  display: inline-block;
  width: auto;
  margin-right: 10px;
  min-height: fit-content;
}

.filter-box {
  border: 0px solid white;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 12px;
  padding: 5px;
  margin: 0;
}

.fltr-btn {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.active-filter {
  padding: 2px;
  border: 1px solid #6c757d;
  /* Borde azul */
  border-radius: 10px;
}

.filters-show {
  text-decoration: underline;
  margin-top: 10px;
}

.filters-show:hover {
  color: #6c757d;
  text-decoration: none;
  cursor: pointer;
}

.list-box {
  height: calc(100% - 60px);
}
</style>
